<div class="flex flex-col flex-auto min-w-0">
    <div class="sm:absolute sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div *ngIf="isLoaded" class="shadow-lg">
                    <div class="flex border-b mt-4">
                        <!-- <mat-tab-group dynamicHeight class="w-full h-full" [selectedIndex]="tabIndex" (selectedIndexChange)="setTabIndex($event)">
                            <mat-tab label="Dossier d'intervention">
                                <ng-template matTabContent>
                                    <app-dossier-intervention-v2 (valueChanged)="this.unsavedChanges = $event"></app-dossier-intervention-v2>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Créance">
                                <ng-template matTabContent>
                                    <app-formulaire-autorisation-intervention
                                        [dossierIntervention]="currentDossierIntervention"
                                        (submitEvent)="refresh($event)"
                                        (valueChangedEvent)="this.unsavedChanges = $event"
                                    ></app-formulaire-autorisation-intervention>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Photos">
                                <ng-template matTabContent>
                                    <app-photo-dossier-intervention [currentDossierIntervention]="currentDossierIntervention"></app-photo-dossier-intervention>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Interventions">
                                <ng-template matTabContent>
                                    <app-fiche-intervention [currentDossierIntervention]="currentDossierIntervention"></app-fiche-intervention>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Heures travaillees">
                                <ng-template matTabContent>
                                    <app-heure-travaillee [currentDossierIntervention]="currentDossierIntervention" (submitEvent)="getDossierIntervention($event);" (valueChangedEvent)="this.unsavedChanges = $event"></app-heure-travaillee>
                                </ng-template>
                            </mat-tab>
                            <mat-tab label="Rapport psychométrique">
                                <ng-template matTabContent>
                                    <app-dossier-rapport-psychometrique [currentDossierIntervention]="currentDossierIntervention"></app-dossier-rapport-psychometrique>
                                </ng-template>
                            </mat-tab>
                        </mat-tab-group> -->

                        <div class="tabs-container">
                            <div class="tabs flex ml-7">
                                <button *ngFor="let tab of tabs; let i = index"
                                        class="flex-1 tab-button text-sm font-semibold transition-all duration-300 ease-in-out px-5 py-0 mr-2"
                                        [class.active]="i === tabIndex"
                                        (click)="onTabClick(i)">
                                    {{ tab.label }}
                                </button>
                            </div>

                            <div class="tab-content p-5">
                                <ng-container *ngIf="tabIndex === 0">
                                    <app-dossier-intervention-v2 (valueChanged)="this.unsavedChanges = $event"></app-dossier-intervention-v2>
                                </ng-container>
                                <ng-container *ngIf="tabIndex === 1">
                                    <app-formulaire-autorisation-intervention
                                        [dossierIntervention]="currentDossierIntervention"
                                        (submitEvent)="refresh($event)"
                                        (valueChangedEvent)="this.unsavedChanges = $event">
                                    </app-formulaire-autorisation-intervention>
                                </ng-container>
                                <ng-container *ngIf="tabIndex === 2">
                                    <app-photo-dossier-intervention [currentDossierIntervention]="currentDossierIntervention"></app-photo-dossier-intervention>
                                </ng-container>
                                <ng-container *ngIf="tabIndex === 3">
                                    <app-fiche-intervention [currentDossierIntervention]="currentDossierIntervention"></app-fiche-intervention>
                                </ng-container>
                                <ng-container *ngIf="tabIndex === 4">
                                    <app-heure-travaillee [currentDossierIntervention]="currentDossierIntervention"
                                                          (submitEvent)="getDossierIntervention($event)"
                                                          (valueChangedEvent)="this.unsavedChanges = $event">
                                    </app-heure-travaillee>
                                </ng-container>
                                <ng-container *ngIf="tabIndex === 5">
                                    <app-dossier-rapport-psychometrique [currentDossierIntervention]="currentDossierIntervention"></app-dossier-rapport-psychometrique>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .tabs {
        max-width: 60%;
        white-space: nowrap;
    }

    .tab-button {
        font-family:"Inter var", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        color: rgba(100, 116, 139, 0.8);
        height: 40px;

        &.active {
            background: rgba(51, 65, 85, 0.1);
            border-radius: 50px;
            color: rgb(54, 72, 102);
        }
    }

    .tabs-container {
        width: 100%;
    }

    @media (max-width: 1152px) {
        .tabs {
            max-width: unset;
            white-space: normal;
        }
    }
</style>
